import { render, staticRenderFns } from "./rate-data.vue?vue&type=template&id=f20f6934&"
import script from "./rate-data.vue?vue&type=script&lang=js&"
export * from "./rate-data.vue?vue&type=script&lang=js&"
import style0 from "./rate-data.vue?vue&type=style&index=0&id=f20f6934&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports